import React, { useEffect, useState } from "react";
import { Menu, Phone, X } from "lucide-react";
import { LOGO_URL, navLinks, PHONE, PHONE_RAW } from "../mock";
import { Button } from "./ui/button";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("#home");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (href) => {
    setActive(href);
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#fff9f3]/90 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-5 lg:px-8 h-20 sm:h-24 lg:h-32 flex items-center justify-between">
        <a href="#home" onClick={(e)=>{e.preventDefault();handleClick("#home");}} className="flex items-center gap-2">
          <img src={LOGO_URL} alt="Nanhe Kadam" className="h-20 w-20 sm:h-28 sm:w-28 lg:h-40 lg:w-40 object-contain" />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={(e) => { e.preventDefault(); handleClick(n.href); }}
              className={`text-[15px] font-medium transition-colors relative pb-1 ${
                active === n.href ? "text-[#ee6c4d]" : "text-[#122b45] hover:text-[#ee6c4d]"
              }`}
            >
              {n.label}
              {active === n.href && (
                <span className="absolute left-0 right-0 -bottom-0.5 h-[2px] bg-[#ee6c4d] rounded-full" />
              )}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-5">
          <a href={`tel:${PHONE_RAW}`} className="flex items-center gap-2 text-[#122b45] hover:text-[#ee6c4d] text-sm font-medium">
            <Phone className="w-4 h-4" />
            {PHONE}
          </a>
          <Button
            onClick={() => handleClick("#contact")}
            className="bg-[#122b45] hover:bg-[#0d2138] text-white rounded-full px-5 h-11"
          >
            Book Consultation
          </Button>
        </div>

        <button className="lg:hidden p-2 text-[#122b45]" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#fff9f3] border-t border-orange-100 px-5 py-5 space-y-3">
          {navLinks.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={(e) => { e.preventDefault(); handleClick(n.href); }}
              className="block text-[15px] font-medium text-[#122b45] py-1.5"
            >
              {n.label}
            </a>
          ))}
          <Button onClick={() => handleClick("#contact")} className="w-full bg-[#122b45] text-white rounded-full mt-2">
            Book Consultation
          </Button>
        </div>
      )}
    </header>
  );
}
